module.exports = __webpack_public_path__ + "img/delete_black_24dp@2x.13893891.png";